import { helpers } from '@mf-node/mf-vue-components'

export const getWhitelabelConfiguration = helpers.whitelabel.getWhitelabelConfiguration

export default {
  install(Vue, { env }) {
    const getWhitelabelLogo = () => {
      return require(`@/whitelabel/${env?.VUE_APP_WHITELABEL || 'mercafacil'}/logo.png`)
    }

    Vue.prototype.$getWhitelabelConfiguration = Vue.getWhitelabelConfiguration = getWhitelabelConfiguration
    Vue.prototype.$getWhitelabelLogo = Vue.getWhitelabelLogo = getWhitelabelLogo
  },
}
